import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "antd";
import {
  TeamOutlined,
  ApartmentOutlined,
  AuditOutlined,
  CarryOutOutlined,
} from "@ant-design/icons";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import "./DashboardStats.scss";

// Count helper: handles a raw array or a { data: [] } / { period, data } wrapper.
const countOf = (data) => {
  if (Array.isArray(data)) return data.length;
  if (Array.isArray(data?.data)) return data.data.length;
  return 0;
};

// KPI summary cards. Each count loads independently and degrades to "-" on
// failure so one bad endpoint never blanks the dashboard.
const DashboardStats = () => {
  const [stats, setStats] = useState({
    employees: null,
    departments: null,
    postings: null,
    leaves: null,
  });

  useEffect(() => {
    let active = true;
    const safe = async (url) => {
      try {
        const r = await axiosInstance.get(url);
        return countOf(r.data);
      } catch (e) {
        return null;
      }
    };
    (async () => {
      const [employees, departments, postings, leaves] = await Promise.all([
        safe(API.employee.getAllOverview()),
        safe(API.department.getList),
        safe(API.hiringJobPosting.getAllPostings),
        safe(API.leaveRequest.getAll),
      ]);
      if (active) setStats({ employees, departments, postings, leaves });
    })();
    return () => {
      active = false;
    };
  }, []);

  const cards = [
    {
      title: "Employees",
      value: stats.employees,
      icon: <TeamOutlined />,
      gradient: "linear-gradient(135deg,#2E7D32,#66BB6A)",
    },
    {
      title: "Departments",
      value: stats.departments,
      icon: <ApartmentOutlined />,
      gradient: "linear-gradient(135deg,#1565C0,#42A5F5)",
    },
    {
      title: "Open Job Postings",
      value: stats.postings,
      icon: <AuditOutlined />,
      gradient: "linear-gradient(135deg,#E65100,#FFA726)",
    },
    {
      title: "Leave Requests",
      value: stats.leaves,
      icon: <CarryOutOutlined />,
      gradient: "linear-gradient(135deg,#6A1B9A,#AB47BC)",
    },
  ];

  return (
    <Row gutter={[20, 20]}>
      {cards.map((c) => (
        <Col xs={24} sm={12} xl={6} key={c.title}>
          <Card className="kpi-card" bordered={false}>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <div className="kpi-icon" style={{ background: c.gradient }}>
                {c.icon}
              </div>
              <div>
                <div className="kpi-value">{c.value === null ? "-" : c.value}</div>
                <div className="kpi-label">{c.title}</div>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardStats;
